import { TranslocoService } from '@ngneat/transloco';
import { StatusTagConfiguration } from '@platform-frontend/ui-tools';
import { MARKETPLACE_TRANSLOCO_SCOPE } from '../../marketplace-transloco-scope';
import { ProductEnvironment } from './product-environment';

export const DEMO_STATUS_TAG_CONFIGURATIONS: (translocoService: TranslocoService) => StatusTagConfiguration<ProductEnvironment>[] = (
  translocoService: TranslocoService
) => [
  { status: 'DEMO', class: 'warning', tagText: translocoService.selectTranslate('product.demoStatusTags.demoStatus', {}, MARKETPLACE_TRANSLOCO_SCOPE) },
  { status: 'PREVIEW', class: 'warning', tagText: translocoService.selectTranslate('product.demoStatusTags.previewStatus', {}, MARKETPLACE_TRANSLOCO_SCOPE) }
];
